<div id="mySidenav" class="sidenav">
  <div *ngIf="isNavOpen; else navClosedIcon">
    <div class="avatar-container-open">
      <div class="avatar-icon">
        <i class="dx-icon-user dx-avatar" style="font-size: x-large;"></i>
        <div class="avatar-text">
          {{ isLandingMenuContext ? '' : (chosenLegalEntity || '') }}
        </div>
      </div>
    </div>
  </div>
  <ng-template #navClosedIcon>
    <div class="avatar-container-closed">
      <div class="avatar-icon">
        <i class="dx-icon-user dx-avatar" style="font-size: x-large;padding: 7px 6px 3 px 6px;"></i>
      </div>
    </div>
  </ng-template>

  <div *ngIf="isNavOpen; else navClosed">

    <!-- William Strike users: Upload Payroll only (see isPayrollOnlyUser) -->
    <ng-container *ngIf="!isPayrollOnlyUser">
    <!-- Entity Dashboard -->
    <ng-container *appCheckPermission="null; permissions: ['business.view.all', 'business.view.own','business.edit.all','business.edit.own']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_entity_dashboard"
      (click)="menuActive('Dashboard')"
      [ngClass]="{
        'icon-button-container-open-active': router.url == '/entity-dashboard',
        'icon-button-container-open': router.url != '/entity-dashboard'
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-chart" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">Dashboard</div>
      </div>
      <dx-tooltip
        target="#menu_item_entity_dashboard"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Dashboard</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Entity Admin Dashboard (Admin Dashboard filtered to the selected legal entity) -->
    <ng-container *appCheckPermission="null; permissions: ['todo.view', 'todo.edit']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_entity_admin_dashboard"
      (click)="menuActive('Entity Admin Dashboard')"
      [ngClass]="{
        'icon-button-container-open-active': isCurrentRoute('/entity-admin-dashboard'),
        'icon-button-container-open': !isCurrentRoute('/entity-admin-dashboard')
      }"
    >
      <div class="open-icon-container">
        <!-- material-symbols:space-dashboard-outline -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" style="width: 1.5rem; height: 1.5rem; flex-shrink: 0">
          <path fill="white" d="M19 21H5q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v14q0 .825-.587 1.413T19 21m-8-2V5H5v14zm2 0h6v-7h-6zm0-9h6V5h-6z" />
        </svg>
        <div class="nav-button-text">Admin Dashboard</div>
      </div>
      <dx-tooltip
        target="#menu_item_entity_admin_dashboard"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Admin Dashboard</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Legal entity setup -->
    <ng-container *appCheckPermission="null; permissions: ['business.view.own','business.view.all','business.edit.own','business.edit.all']; requireLegalEntityContext: false">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_legal_entity_setup"
      (click)="menuActive('Legal entity setup')"
      [ngClass]="{
        'icon-button-container-open-active': isCurrentRoute('/legal-entity-setup'),
        'icon-button-container-open': !isCurrentRoute('/legal-entity-setup')
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-description" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">Legal entity setup</div>
      </div>
      <dx-tooltip
        target="#menu_item_legal_entity_setup"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Legal entity setup</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Payment runs -->
    <ng-container *appCheckPermission="null; permissions: ['payroll.view','payroll.edit']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_payment_runs"
      (click)="menuActive('Payment runs')"
      [ngClass]="{
        'icon-button-container-open-active': router.url == '/payment-runs',
        'icon-button-container-open': router.url != '/payment-runs'
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-money" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">Payment runs</div>
      </div>
      <dx-tooltip
        target="#menu_item_payment_runs"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Payment runs</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Manage Members -->
    <ng-container *appCheckPermission="null; permissions: ['member.view','member.edit','member.product.view','member.product.edit']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext && isProductChosen && isPaymentMethodAdded"
      id="menu_item_manage_members"
      (click)="menuActive('Manage Members')"
      [ngClass]="{
        'icon-button-container-open-active': router.url.includes('manage-employees'),
        'icon-button-container-open': !router.url.includes('manage-employees')
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-hierarchy" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">Manage Members</div>
      </div>
      <dx-tooltip
        target="#menu_item_manage_members"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Manage Members</div>
      </dx-tooltip>
    </div>
    <!-- Manage Members - Disabled State -->
    <div
      *ngIf="!isLandingMenuContext && (!isProductChosen || !isPaymentMethodAdded)"
      id="menu_item_manage_members_disabled"
      [ngClass]="'icon-button-container-open'"
    >
      <div class="open-icon-container">
        <i class="dx-icon-clear" style="font-size: 1.5rem; color: grey"></i>
        <div class="nav-button-text-disabled">Manage Members</div>
      </div>
      <dx-tooltip
        target="#menu_item_manage_members_disabled"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <ng-container *ngIf="!isProductChosen && isPaymentMethodAdded">
          <div *dxTemplate="let data = data; of: 'content'">No Products Chosen</div>
        </ng-container>
        <ng-container *ngIf="isProductChosen && !isPaymentMethodAdded">
          <div *dxTemplate="let data = data; of: 'content'">No Payment Methods Added</div>
        </ng-container>
        <ng-container *ngIf="!isProductChosen && !isPaymentMethodAdded">
          <div *dxTemplate="let data = data; of: 'content'">Please add product and payment method to access Manage Members</div>
        </ng-container>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Products (only when legal entity is selected) -->
    <ng-container *appCheckPermission="null; permissions: ['legalentity.products.view', 'legalentity.products.edit']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_products"
      (click)="menuActive('Products')"
      [ngClass]="{
        'icon-button-container-open-active': router.url.includes('/products'),
        'icon-button-container-open': !router.url.includes('/products')
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-box" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">Products</div>
      </div>
      <dx-tooltip
        target="#menu_item_products"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Products</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Manage Products -->
    <ng-container *appCheckPermission="null; permissions: ['product.admin.view', 'product.admin.edit']; requireLegalEntityContext: false">
    <div
      *ngIf="isLandingMenuContext"
      id="menu_item_manage_products"
      (click)="menuActive('Manage Products')"
      [ngClass]="{
        'icon-button-container-open-active': router.url.includes('manage-products') || router.url.includes('product-configuration'),
        'icon-button-container-open': !router.url.includes('manage-products') && !router.url.includes('product-configuration')
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-box" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">Manage Products</div>
      </div>
      <dx-tooltip
        target="#menu_item_manage_products"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Manage Products</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Investment Solutions -->
    <ng-container *appCheckPermission="null; permissions: ['product.admin.view', 'product.admin.edit']; requireLegalEntityContext: false">
      <div
        id="menu_item_investment_solutions"
        (click)="menuActive('Investment Solutions')"
        [ngClass]="{
          'icon-button-container-open-active': router.url == '/product-solutions',
          'icon-button-container-open': router.url != '/product-solutions'
        }"
      >
        <div class="open-icon-container">
          <i class="dx-icon-datatrending" style="font-size: 1.5rem; color: white"></i>
          <div class="nav-button-text">Investment Solutions</div>
        </div>
        <dx-tooltip
          target="#menu_item_investment_solutions"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          [hideOnOutsideClick]="false"
        >
          <div *dxTemplate="let data = data; of: 'content'">Investment Solutions</div>
        </dx-tooltip>
      </div>
      </ng-container>

    <!-- Broadcast -->
    <ng-container *appCheckPermission="null; permissions: ['notification.manage']; requireLegalEntityContext: false">
      <div
        id="menu_item_broadcast"
        (click)="menuActive('Broadcast')"
        [ngClass]="{
          'icon-button-container-open-active': router.url == '/broadcast',
          'icon-button-container-open': router.url != '/broadcast'
        }"
      >
        <div class="open-icon-container">
          <i class="dx-icon-bell" style="font-size: 1.5rem; color: white"></i>
          <div class="nav-button-text">Broadcast</div>
        </div>
        <dx-tooltip
          target="#menu_item_broadcast"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          [hideOnOutsideClick]="false"
        >
          <div *dxTemplate="let data = data; of: 'content'">Broadcast</div>
        </dx-tooltip>
      </div>
    </ng-container>

    <!-- Admin Users -->
    <ng-container *appCheckPermission="null; permissions: ['user.manage']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_admin_users"
      (click)="menuActive('Admin Users')"
      [ngClass]="{
        'icon-button-container-open-active': router.url.includes('manage-users'),
        'icon-button-container-open': !router.url.includes('manage-users')
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-accountbox" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">Admin Users</div>
      </div>
      <dx-tooltip
        target="#menu_item_admin_users"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Admin Users</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Manage Users -->
    <ng-container *appCheckPermission="null; permissions: ['user.manage']; requireLegalEntityContext: false">
    <div
      *ngIf="isLandingMenuContext"
      id="menu_item_admin_users"
      (click)="menuActive('Manage Users')"
      [ngClass]="{
        'icon-button-container-open-active': router.url.includes('manage-users'),
        'icon-button-container-open': !router.url.includes('manage-users')
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-accountbox" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">Manage Users</div>
      </div>
      <dx-tooltip
        target="#menu_item_admin_users"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Admin Users</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Roles -->
    <ng-container *appCheckPermission="null; permissions: ['rolesperm.view','rolesperm.edit']; requireLegalEntityContext: false">
    <div
      id="menu_item_roles"
      (click)="menuActive('Roles')"
      [ngClass]="{
        'icon-button-container-open-active': router.url.includes('roles'),
        'icon-button-container-open': !router.url.includes('roles')
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-group" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">Roles</div>
      </div>
      <dx-tooltip
        target="#menu_item_roles"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Roles</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- ASQ Dashboard -->
    <ng-container *appCheckPermission="null; permissions: ['asq.admin.view']; requireLegalEntityContext: false">
    <div
      id="menu_item_asq_dashboard"
      (click)="menuActive('ASQ Dashboard')"
      [ngClass]="{
        'icon-button-container-open-active': router.url.includes('/asq'),
        'icon-button-container-open': !router.url.includes('/asq')
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-refresh" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">ASQ Dashboard</div>
      </div>
      <dx-tooltip
        target="#menu_item_asq_dashboard"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">ASQ Dashboard</div>
      </dx-tooltip>
    </div>
    </ng-container>
    </ng-container>

    <!-- Upload Payroll -->
    <ng-container *appCheckPermission="null; permissions: ['payroll.upload']; requireLegalEntityContext: false">
    <div
      id="menu_item_upload_payroll"
      (click)="menuActive('Upload Payroll')"
      [ngClass]="{
        'icon-button-container-open-active': router.url == '/legal-entities/payroll-upload',
        'icon-button-container-open': router.url != '/legal-entities/payroll-upload'
      }"
    >
      <div class="open-icon-container">
        <i class="dx-icon-upload" style="font-size: 1.5rem; color: white"></i>
        <div class="nav-button-text">Upload Payroll</div>
      </div>
      <dx-tooltip
        target="#menu_item_upload_payroll"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Upload Payroll</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- SIGNOUT DIV - OPEN -->
    <div (click)="activateDrawer()">
      <div class="signout-button-container-open">
        <div class="open-icon-container-nav-control">
          <i class="dx-icon-chevronleft" style="font-size: 1rem; margin-top: 15px; color: white"></i>
        </div>
      </div>
    </div>
  </div>

  <ng-template #navClosed>

    <!-- William Strike users: Upload Payroll only (see isPayrollOnlyUser) -->
    <ng-container *ngIf="!isPayrollOnlyUser">
    <!-- Entity Dashboard -->
    <ng-container *appCheckPermission="null; permissions: ['business.view.all', 'business.view.own','business.edit.all','business.edit.own']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_entity_dashboard_closed"
      (click)="menuActive('Dashboard')"
      [ngClass]="{
        'icon-button-container-closed-active': router.url == '/entity-dashboard',
        'icon-button-container-closed': router.url != '/entity-dashboard'
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-chart" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_entity_dashboard_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Dashboard</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Entity Admin Dashboard (Admin Dashboard filtered to the selected legal entity) -->
    <ng-container *appCheckPermission="null; permissions: ['todo.view', 'todo.edit']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_entity_admin_dashboard_closed"
      (click)="menuActive('Entity Admin Dashboard')"
      [ngClass]="{
        'icon-button-container-closed-active': isCurrentRoute('/entity-admin-dashboard'),
        'icon-button-container-closed': !isCurrentRoute('/entity-admin-dashboard')
      }"
    >
      <div class="closed-icon-container">
        <!-- material-symbols:space-dashboard-outline -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" style="width: 1.5rem; height: 1.5rem; flex-shrink: 0">
          <path fill="white" d="M19 21H5q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v14q0 .825-.587 1.413T19 21m-8-2V5H5v14zm2 0h6v-7h-6zm0-9h6V5h-6z" />
        </svg>
      </div>
      <dx-tooltip
        target="#menu_item_entity_admin_dashboard_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Admin Dashboard</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Legal entity setup -->
    <ng-container *appCheckPermission="null; permissions: ['business.view.own','business.view.all','business.edit.own','business.edit.all']; requireLegalEntityContext: false">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_legal_entity_setup_closed"
      (click)="menuActive('Legal entity setup')"
      [ngClass]="{
        'icon-button-container-closed-active': isCurrentRoute('/legal-entity-setup'),
        'icon-button-container-closed': !isCurrentRoute('/legal-entity-setup')
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-description" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_legal_entity_setup_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Legal entity setup</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Payment runs -->
    <ng-container *appCheckPermission="null; permissions: ['payroll.view','payroll.edit']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_payment_runs_closed"
      (click)="menuActive('Payment runs')"
      [ngClass]="{
        'icon-button-container-closed-active': router.url == '/payment-runs',
        'icon-button-container-closed': router.url != '/payment-runs'
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-money" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_payment_runs_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Payment runs</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Manage Members -->
    <ng-container *appCheckPermission="null; permissions: ['member.view','member.edit','member.product.view','member.product.edit']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext && isProductChosen && isPaymentMethodAdded"
      id="menu_item_manage_members_closed"
      (click)="menuActive('Manage Members')"
      [ngClass]="{
        'icon-button-container-closed-active': router.url.includes('manage-employees'),
        'icon-button-container-closed': !router.url.includes('manage-employees')
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-hierarchy" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_manage_members_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Manage Members</div>
      </dx-tooltip>
    </div>
    <!-- Manage Members - Disabled State -->
    <div
      *ngIf="!isLandingMenuContext && (!isProductChosen || !isPaymentMethodAdded)"
      id="menu_item_manage_members_disabled_closed"
      [ngClass]="'icon-button-container-closed'"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-clear" style="font-size: 1.5rem; color: grey"></i>
      </div>
      <dx-tooltip
        target="#menu_item_manage_members_disabled_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <ng-container *ngIf="!isProductChosen && isPaymentMethodAdded">
          <div *dxTemplate="let data = data; of: 'content'">No Products Chosen</div>
        </ng-container>
        <ng-container *ngIf="isProductChosen && !isPaymentMethodAdded">
          <div *dxTemplate="let data = data; of: 'content'">No Payment Methods Added</div>
        </ng-container>
        <ng-container *ngIf="!isProductChosen && !isPaymentMethodAdded">
          <div *dxTemplate="let data = data; of: 'content'">Please add product and payment method to access Manage Members</div>
        </ng-container>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Products (closed nav, only when legal entity is selected) -->
    <ng-container *appCheckPermission="null; permissions: ['legalentity.products.view', 'legalentity.products.edit']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_products_closed"
      (click)="menuActive('Products')"
      [ngClass]="{
        'icon-button-container-closed-active': router.url.includes('/products'),
        'icon-button-container-closed': !router.url.includes('/products')
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-box" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_products_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Products</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Manage Products -->
    <ng-container *appCheckPermission="null; permissions: ['product.admin.view', 'product.admin.edit']; requireLegalEntityContext: false">
    <div
      *ngIf="isLandingMenuContext"
      id="menu_item_manage_products_closed"
      (click)="menuActive('Manage Products')"
      [ngClass]="{
        'icon-button-container-closed-active': router.url.includes('manage-products') || router.url.includes('product-configuration'),
        'icon-button-container-closed': !router.url.includes('manage-products') && !router.url.includes('product-configuration')
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-box" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_manage_products_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Manage Products</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Investment Solutions -->
    <ng-container *appCheckPermission="null; permissions: ['product.admin.view', 'product.admin.edit']; requireLegalEntityContext: false">
      <div
        id="menu_item_investment_solutions_closed"
        (click)="menuActive('Investment Solutions')"
        [ngClass]="{
          'icon-button-container-closed-active': router.url == '/product-solutions',
          'icon-button-container-closed': router.url != '/product-solutions'
        }"
      >
        <div class="closed-icon-container">
          <i class="dx-icon-datatrending" style="font-size: 1.5rem; color: white"></i>
        </div>
        <dx-tooltip
          target="#menu_item_investment_solutions_closed"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          [hideOnOutsideClick]="false"
        >
          <div *dxTemplate="let data = data; of: 'content'">Investment Solutions</div>
        </dx-tooltip>
      </div>
    </ng-container>

    <!-- Broadcast -->
    <ng-container *appCheckPermission="null; permissions: ['notification.manage']; requireLegalEntityContext: false">
      <div
        id="menu_item_broadcast_closed"
        (click)="menuActive('Broadcast')"
        [ngClass]="{
          'icon-button-container-closed-active': router.url == '/broadcast',
          'icon-button-container-closed': router.url != '/broadcast'
        }"
      >
        <div class="closed-icon-container">
          <i class="dx-icon-bell" style="font-size: 1.5rem; color: white"></i>
        </div>
        <dx-tooltip
          target="#menu_item_broadcast_closed"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          [hideOnOutsideClick]="false"
        >
          <div *dxTemplate="let data = data; of: 'content'">Broadcast</div>
        </dx-tooltip>
      </div>
    </ng-container>

    <!-- Admin Users -->
    <ng-container *appCheckPermission="null; permissions: ['user.manage']; requireLegalEntityContext: true">
    <div
      *ngIf="!isLandingMenuContext"
      id="menu_item_admin_users_closed"
      (click)="menuActive('Admin Users')"
      [ngClass]="{
        'icon-button-container-closed-active': router.url.includes('manage-users'),
        'icon-button-container-closed': !router.url.includes('manage-users')
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-accountbox" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_admin_users_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Admin Users</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Manage Users -->
    <ng-container *appCheckPermission="null; permissions: ['user.manage']; requireLegalEntityContext: false">
    <div
      *ngIf="isLandingMenuContext"
      id="menu_item_admin_users_closed"
      (click)="menuActive('Manage Users')"
      [ngClass]="{
        'icon-button-container-closed-active': router.url.includes('manage-users'),
        'icon-button-container-closed': !router.url.includes('manage-users')
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-accountbox" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_admin_users_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Manage Users</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- Roles -->
    <ng-container *appCheckPermission="null; permissions: ['rolesperm.view','rolesperm.edit']; requireLegalEntityContext: false">
    <div
      id="menu_item_roles_closed"
      (click)="menuActive('Roles')"
      [ngClass]="{
        'icon-button-container-closed-active': router.url.includes('roles'),
        'icon-button-container-closed': !router.url.includes('roles')
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-group" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_roles_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Roles</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- ASQ Dashboard -->
    <ng-container *appCheckPermission="null; permissions: ['asq.admin.view']; requireLegalEntityContext: false">
    <div
      id="menu_item_asq_dashboard_closed"
      (click)="menuActive('ASQ Dashboard')"
      [ngClass]="{
        'icon-button-container-closed-active': router.url.includes('/asq'),
        'icon-button-container-closed': !router.url.includes('/asq')
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-refresh" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_asq_dashboard_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">ASQ Dashboard</div>
      </dx-tooltip>
    </div>
    </ng-container>
    </ng-container>

    <!-- Upload Payroll -->
    <ng-container *appCheckPermission="null; permissions: ['payroll.upload']; requireLegalEntityContext: false">
    <div
      id="menu_item_upload_payroll_closed"
      (click)="menuActive('Upload Payroll')"
      [ngClass]="{
        'icon-button-container-closed-active': router.url == '/legal-entities/payroll-upload',
        'icon-button-container-closed': router.url != '/legal-entities/payroll-upload'
      }"
    >
      <div class="closed-icon-container">
        <i class="dx-icon-upload" style="font-size: 1.5rem; color: white"></i>
      </div>
      <dx-tooltip
        target="#menu_item_upload_payroll_closed"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data; of: 'content'">Upload Payroll</div>
      </dx-tooltip>
    </div>
    </ng-container>

    <!-- CLOSE SIDE NAV - CONTAINER-->
    <div (click)="activateDrawer()">
      <div class="signout-button-container-closed">
        <div class="closed-icon-container-nav-control">
          <i class="dx-icon-chevronright nav-bar-chevron" style="font-size: 1rem; margin-top: 15px; color: white"></i>
        </div>
      </div>
    </div>
  </ng-template>
</div>
